/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useEffect, useState } from "react";
import { Heading } from "../typography/Heading";
import JobCard from "./jobCard";
import { JobPost } from "@/types/schema";
import { removeUnderscoreAndSpaceText } from "@/lib/utils";

export default function JobBoard() {
  const [data, setData] = useState<JobPost[]>([]);
  const [error, setError] = useState<any>(null);

  useEffect(() => {


    fetch("/api/get-jobs")
      .then((res) => {

        return res.json();
      })
      .then((json) => {

        setData(json as JobPost[]);
      })
      .catch((err) => {

        setError(err);
      });
  }, []);

  const groupedJobs = data.reduce(
    (acc, job) => {
      if (!acc[job.job_category]) acc[job.job_category] = [];
      acc[job.job_category].push(job);
      return acc;
    },
    {} as Record<string, JobPost[]>,
  );

  if (error) {
    return <div>Error loading jobs</div>;
  }

  if (!data.length) {
    return (
      <Heading
        className="mb-70px lg:mb-170px"
        as="h5"
        size="h5"
        weight={400}
        color="black"
      >
        No open positions at the moment
      </Heading>
    );
  }

  return (
    <main className="pt-0 mb-70px md:pt-12 md:mb-170px">
      <div className="space-y-16">
        {Object.entries(groupedJobs).map(([category, categoryJobs]) => (
          <div key={category} className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Category title */}
            <div className="md:col-span-1">
              <Heading
                className="sticky top-8"
                as="h5"
                size="h5"
                weight={400}
                color="black"
              >
                {removeUnderscoreAndSpaceText(category)}
              </Heading>
            </div>

            {/* Job cards */}
            <div className="md:col-span-3 space-y-4 flex flex-col items-end">
              {categoryJobs.map((job) => (
                <JobCard key={job.id} job={job} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}
